<template>
  <div
    :class="{
      'h-full': !inIframe,
    }"
  >
    <p
      v-if="viewLoadError"
      class="ma-8 pa-6 rounded bg-white"
    >
      {{ viewLoadError }}
    </p>

    <TheLandscape
      v-else-if="showView"
      :exodia-props="exodiaProps"
      :fields="columns"
      :record-id="recordId"
      :view="view"
      :outlined="false"
      filter-main-content
      :page-state-component-key="pageStateComponentKey"
      show-workflow
      class="h-full"
      @refetch="refresh"
    />

    <LogoLoading v-else />
  </div>
</template>

<script lang="ts">
import LogoLoading from '~/components/LogoLoading.vue';
import { mapGetters, mapState } from '~/assets/javascript/modules/vuex';
import ROUTES from '~/assets/javascript/constants/routes';
import { VIEW_TYPES } from '~/assets/javascript/constants';

export default {
  name: 'PublicViewRecordShow',
  components: {
    TheLandscape: defineAsyncComponent(() => import('~/components/views/the-landscape/index.vue')),
    LogoLoading,
  },
  async setup() {
    const store = {
      ...mapState('view', ['view']),
      // eslint-disable-next-line vue/no-unused-properties
      ...mapGetters('workspace', ['workspaceName']),
    };

    definePageMeta({
      layout: 'public',
      isPublic: true,
    });

    const { refresh } = await useAsyncData(async () => {
      await useViewFetch({ isPublic: true, skipBuildHead: true });

      useAnalyticsPage('public-view-record-show', { name: store.view.value.page_name }, { immediate: true });
    });

    const {
      recordId,
      exodiaProps,
    } = useRecordPage(ROUTES.public.view.record.routeName);

    buildHead({
      titleTemplate: `%s - ${store.workspaceName.value}`,
      title: computed(() => store.view.value?.page_name),
    });

    useTrackAppUsage('show');

    return {
      ...store,
      recordId,
      exodiaProps,
      inIframe: useInIframe(),
      refresh,
    };
  },
  data() {
    return {
      viewLoadError: null,
      columns: [],
    };
  },
  computed: {
    showView() {
      return Boolean(this.view) && this.view.id === this.$route.params.viewId;
    },
    openRecordMode() {
      return VIEW_TYPES[this.view.page_type]?.components.find(
        component => component.key === 'single_item',
      )?.main_section?.openRecordMode || 'none';
    },
    pageStateComponentKey() {
      return this.openRecordMode === 'dialog' ? 'index' : 'single_item';
    },
  },
};
</script>
